<template>
  <div class="is-relative">
    <p class="mb-1">{{title}}</p>
    <b-field class="input-none input-search-3 placeholder-specific-search">
      <b-autocomplete
        v-model="keyword"
        :placeholder="placeholder"
        :open-on-focus="true"
        :clearable="true"
        :data="filteredData"
        field="name"
        @select="(option) => handleSelectItem(option)"
      >
        <template slot-scope="props">
          <div class="item-client-wrapper">
            <p>{{ props.option.name }}</p>
          </div>
        </template>
      </b-autocomplete>
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'InputAutocompleteSpecificSearch',
  props: {
    title: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      keyword: ''
    }
  },
  computed: {
    filteredData () {
      return this.data.filter((option) => {
        return option.name.toString().toLowerCase().indexOf(this.keyword ? this.keyword.toLowerCase() : '') >= 0
      })
    }
  },
  methods: {
    handleSelectItem (item) {
      this.$emit('select', item)
    }
  }
}
</script>
